const NAV_WIDTH = '150px';

export const hcpDataChangeRequestStyles = {
	title: {
		display: 'flex',
		flexDirection: 'column',
		gap: 1
	},

	mainHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		gap: 1
	},

	textTitle: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		minWidth: 0,
		fontSize: '1.25rem',
		fontWeight: 700
	},

	titleActions: {
		display: 'flex',
		alignItems: 'flex-end',
		flexDirection: 'row',
		flexWrap: 'nowrap',
		gap: 1
	},

	closeIcon: {
		color: 'text.secondary',
		cursor: 'pointer'
	},

	dcrLink: {
		textTransform: 'none'
	},

	allFieldsLink: {
		fontWeight: 700
	},

	content: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'row',
		gap: 1,
		pb: 2
	},

	navigation: {
		minWidth: NAV_WIDTH,
		width: NAV_WIDTH,
		flexShrink: 0,
		position: 'sticky',
		top: 0,
		alignSelf: 'flex-start',
		pt: 1
	},

	tabs: {
		'& .MuiTab-root': {
			textTransform: 'none',
			alignItems: 'flex-start',
			textWrap: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			display: 'block',
			textAlign: 'left'
		},
		'& .MuiTabs-indicator': {
			display: 'none'
		},
		'& .Mui-selected': {
			fontWeight: 700
		}
	},

	tabLink: {
		minHeight: '28px',
		height: '28px',
		textDecoration: 'none',
		borderRadius: 2,
		color: 'text.secondary',
		py: 0.75,
		mb: {
			xs: 0,
			sm: 1
		},
		display: 'flex',
		alignItems: 'center'
	},

	formContent: {
		display: 'flex',
		flexDirection: 'column',
		flex: 1,
		minWidth: 0,
		gap: 4.5,
		pt: 1
	},

	actions: {
		backgroundColor: 'background.paper',
		borderTop: '1px solid var(--mui-palette-divider)',
		padding: 2
	},

	reviewFooterBleed: {
		backgroundColor: 'background.paper',
		borderTop: '1px solid var(--mui-palette-divider)',
		px: 2,
		py: 2,
		mt: 0
	},

	loadingIndicatorCustom: {
		height: 208,
		width: '100%'
	},

	mobileNavTabsCustom: {
		tabs: {
			minHeight: 'unset',
			'.MuiTab-root': {
				marginBottom: 0
			}
		}
	},

	formStep: (visible: boolean) => ({
		display: visible ? 'block' : 'none',
		height: '100%'
	})
};
